module.exports = __webpack_public_path__ + "media/app/assets/classes/priest-3d1aae226f8e9b778c877a9662e604e2.jpg";